import { Component, Input } from '@angular/core';
import { ControlContainer } from '@angular/forms';

/**
 * Component that displays errors from a form control if a target is set or from a form if no target were specified.
 *
 * @example
 * <mv-errors-display target="address"></mv-errors-display>
 */
@Component({
  selector: 'mv-errors-display',
  template: `<ion-item *ngIf="errors.keys && errors.keys.length">
  <h3 ion-text color="danger" *ngIf="!target">{{'There are errors' | translate}}</h3>
  <div *ngFor="let labelKey of errors.keys">
    <h4 ion-text color="danger" *ngIf="!target">{{ labelKey | translate }}</h4>
    <div *ngFor="let errorKey of errors[labelKey].keys">
      <p ion-text color="danger" *ngIf="errorKey != 'keys'">{{ 'error.'+ labelKey + '.' + errorKey | uppercase | translate }}</p>
    </div>
  </div>
</ion-item>
`
})
export class ErrorsDisplayComponent {

  /**
   * If set, specific target whose errors will be displayed
   */
  @Input()
  private target: string;

  /**
   * Form containing this container.
   * It's this form whose errors will be displayed
   */
  private group;

  /**
   * Constructor of the component
   *
   * @param cc Control container, element allowing to get the parent form
   */
  constructor(
    private cc: ControlContainer
  ) {
    this.group = this.cc.formDirective;
  }

  /**
   * Retrieves error from the target or from the full form depending on the presence or not of a target
   *
   * @returns errors Object containing the errors retrieved
   */
  get errors() {
    const errors: any = {};

    if (this.target) {
      if (this.group.control.get(this.target) && this.group.control.get(this.target).dirty && this.group.control.get(this.target).errors) {
        errors[this.target] = this.group.control.get(this.target).errors;
        errors[this.target].keys = Object.keys(this.group.control.get(this.target).errors);
      }
    } else {
      for (const control in this.group.form.controls) {
        if (this.group.form.controls[control].dirty && this.group.form.controls[control].errors) {
          errors[control] = this.group.control.get(control).errors;
          errors[control].keys = Object.keys(this.group.control.get(control).errors);
        }
      }
    }
    if (Object.keys(errors)) {
      errors.keys = Object.keys(errors);
    }
    return errors;
  }
}
